import {Component, Inject, OnInit, SimpleChanges} from '@angular/core';
import {ObjectFrom} from '../../dynamic-form/models/input-form';
import {DynamicFormServices} from '../../dynamic-form/services/dynamic-form.services';
import {MyUtils} from 'src/app/services/my-utils.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormGroup} from '@angular/forms';
import {ApplicationService} from 'src/app/services/application.service';
import {InterviewsService} from 'src/app/services/interviews.service';
import {Subscription} from "rxjs";
import {MatSnackBar} from "@angular/material/snack-bar";
import {SnackbarComponent} from "../../snackbar/snackbar/snackbar.component";

@Component({
    selector: 'app-online-rep-comment-dialog',
    templateUrl: './online-rep-comment-dialog.component.html',
    styleUrls: ['./online-rep-comment-dialog.component.scss']
})
export class OnlineRepCommentDialogComponent implements OnInit {

    inputForm: ObjectFrom[];
    subscription?: Subscription;

    formGroup: FormGroup;
    comments?: string = "";
    changeValueSelect: string = "";
    isLoaded: boolean = true;
    isNewTemplate: boolean = false;
    multiresponse: string[] = [];
    customResponses: any = [];
    formValue:any;
    addTemplateLabel :string;

    constructor(
        private dynamicFormService: DynamicFormServices,
        public utils: MyUtils,
        public snackbar: MatSnackBar,
        private applicationService: ApplicationService,
        private interviewService: InterviewsService,
        private dialogRef: MatDialogRef<OnlineRepCommentDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            comments: string;
            response: string;
            reviewId: string,
            dealerId: string,
            marketId: string,
            regionId: string,
            brandId: string,
            section: string,
            customerName: string
        }) {
        this.addTemplateLabel=this.utils.traslatei18n('AddNewTemplate');
        this.interviewService.getResponsesTemplate().subscribe((res: any) => {
            if (res.elements.length > 0) {
                res.elements.forEach((el: any) => {
                    this.customResponses.push({idTemplate: el.idTemplate, response: el.response})
                    this.multiresponse.push(el.idTemplate)
                })
            }
            this.multiresponse.push(this.addTemplateLabel)
        })

        this.inputForm = [
            [
                {
                    formControlName: "commentselect",
                    label: "Comment Response",
                    placeholder: "Choose a response template",
                    value: '',
                    validators: {
                        required: true,
                    },
                    objectSelect: this.multiresponse,
                    template: "select",
                    className: "custom-border",
                    disabled: false,

                },
            ], [
                {
                    formControlName: "titleTemplate",
                    label: "TemplateTitle",
                    placeholder: "Insert Title",
                    value: '',
                    validators: {
                        required: true,
                    },
                    isHidden: true,
                    template: "input",
                    className: "custom-border",
                    disabled: true,
                },
            ],
            [
                {
                    formControlName: "response",
                    label: "TemplateResponse",
                    placeholder: "Insert response template",
                    value: this.parseXml(data.response),
                    validators: {
                        required: true,
                    },
                    template: "textarea",
                    className: "custom-border",
                    disabled: false,
                },
            ]
        ];

        this.formGroup = this.dynamicFormService.generateFormGroup(this.inputForm);

        this.subscriptionCommentSelect()
    }

    subscriptionCommentSelect() {
        this.subscription = this.formGroup.get('commentselect')?.valueChanges.subscribe((value: string) => {

            if (value === this.multiresponse[this.multiresponse.length - 1]) {
                this.isLoaded = false;
                this.inputForm[1][0].isHidden = false;
                this.inputForm[1][0].disabled = false;
                this.inputForm[0][0].value = this.multiresponse[this.multiresponse.length - 1];
                this.formGroup = this.dynamicFormService.generateFormGroup(this.inputForm);
                this.isLoaded = true;
                this.subscriptionCommentSelect()
            } else if (this.inputForm[1][0].disabled === false) {
                this.isLoaded = false;
                this.inputForm[1][0].isHidden = true;
                this.inputForm[1][0].disabled = true;
                this.inputForm[0][0].value = value;
                this.formGroup = this.dynamicFormService.generateFormGroup(this.inputForm);
                this.isLoaded = true;
                this.subscriptionCommentSelect()
            }
            this.valueMultiSelectResponse(value);
            this.formGroup.get('response')?.setValue(this.changeValueSelect);
        });
    }

    ngOnInit(): void {
    }

    changes(changes: SimpleChanges): void {
    }

    valueMultiSelectResponse(value: string) {
        const customResponse = this.customResponses.find((el: any) => el.idTemplate === value);
        this.isNewTemplate = false;
        if (value === this.multiresponse[0]) {
            this.changeValueSelect = customResponse.response;
            this.isNewTemplate = true;
        }
    }


    parseXml(xml: string) {
        if (xml) {
            const parser = new DOMParser();
            const document = parser.parseFromString(xml, "text/html");
            if (document.body.innerHTML.includes("null")) {
                document.body.innerHTML = "";
            }
            return document.body.innerHTML;

        } else {
            return this.changeValueSelect;
        }

    }

    resetDefault() {
        this.multiresponse = [];
        this.inputForm = [
            [
                {
                    formControlName: "commentselect",
                    label: "Comment Response",
                    placeholder: "Choose a response template",
                    value: '',
                    validators: {
                        required: true,
                    },
                    objectSelect: this.multiresponse,
                    template: "select",
                    className: "custom-border",
                    disabled: false,

                },
            ], [
                {
                    formControlName: "titleTemplate",
                    label: "Title",
                    placeholder: "Insert Title",
                    value: '',
                    validators: {
                        required: true,
                    },
                    isHidden: true,
                    template: "input",
                    className: "custom-border",
                    disabled: true,
                },
            ],
            [
                {
                    formControlName: "response",
                    label: "Response",
                    placeholder: "Insert response template",
                    value: this.parseXml(this.data.response),
                    validators: {
                        required: true,
                    },
                    template: "textarea",
                    className: "custom-border",
                    disabled: false,
                },
            ]
        ];
        this.changeValueSelect = this.parseXml(this.data.response);
    }

    onSave() {
        let formValue = this.prepareSaveData();
        if(!formValue)return;
        this.dialogRef.close(formValue);
    }


    onDeleteTemplate() {
        this.interviewService.deleteResponse(this.formGroup.get('commentselect')?.value).subscribe(res => {
                if (res) {this.refreshResponses();}
            }
        )
    }

    onSaveTemplate() {
        let formValue =this.prepareSaveData();
        if(!formValue)return
        this.interviewService.saveResponse(formValue).subscribe((res:any) => {
                if (res) {
                    this.snackbar.openFromComponent(SnackbarComponent, {duration: 3000,
                        panelClass: "positive-bg",data:{message:this.utils.traslatei18n('SavedTemplate'),title:this.utils.traslatei18n('Completed').toUpperCase()},
                    });
                    this.refreshResponses();}
            }
        )
    }

    refreshResponses(){
        this.isLoaded = false;
        this.resetDefault();
        this.interviewService.getResponsesTemplate().subscribe((resp: any) => {
            if (resp.elements.length > 0) {
                resp.elements.forEach((el: any) => {
                    this.customResponses.push({idTemplate: el.idTemplate, response: el.response})
                    this.multiresponse.push(el.idTemplate)
                })
            }
            this.multiresponse.push(this.addTemplateLabel)
            this.formGroup = this.dynamicFormService.generateFormGroup(this.inputForm);
            this.subscriptionCommentSelect()
            this.isLoaded = true;
        })
    }

    prepareSaveData(){
        let formGroupAdded = {
            isPrivateResponse: false,
            reviewId: this.data.reviewId,
            dealerId: this.data.dealerId,
            marketId: this.data.marketId,
            regionId: this.data.regionId,
            brandId: this.data.brandId,
            section: this.applicationService.navBarSelectValue.idItem,
        }
        if (!this.formGroup.valid) return null;
        return {...formGroupAdded, ...this.formGroup.value};
    }
    ngOnDestroy() {
        this.subscription?.unsubscribe();
    }

}
